import axios from 'axios'

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // Send httpOnly cookies with every request
})

// Response interceptor — handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || ''
      // Don't redirect on auth endpoints — useAuth handles verify failures gracefully,
      // and login/register 401s are credential errors, not session expiry
      if (!url.includes('/api/auth/')) {
        localStorage.removeItem('sfcompare_user')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
